import { z as e } from "zod";
import { UserIdSchema as r, RefreshTokenSchema as t, UsernameSchema as i } from "../schemas.js";
var n = /* @__PURE__ */ ((a) => (a.SuperAdmin = "SuperAdmin", a.ReadAdmin = "ReadAdmin", a.WriteAdmin = "WriteAdmin", a.ReadAdvert = "ReadAdvert", a.WriteAdvert = "WriteAdvert", a.ReadPublisher = "ReadPublisher", a.WritePublisher = "WritePublisher", a.ReadExchange = "ReadExchange", a.WriteExchange = "WriteExchange", a.SplitTrafficSourceBySsp = "SplitTrafficSourceBySsp", a.ManageUsers = "ManageUsers", a.AssignAdminRole = "AssignAdminRole", a.ManageAdExchangeBindings = "ManageAdExchangeBindings", a.ManageOwnBilling = "ManageOwnBilling", a))(n || {}), d = /* @__PURE__ */ ((a) => (a.Admin = "admin", a.Manager = "manager", a.AdAdmin = "adAdmin", a.Advert = "adAdvertiser", a.Exchange = "adExchange", a.Publisher = "adPublisher", a))(d || {});
const o = e.enum(n), s = e.enum(d), A = e.object({
  userId: r,
  roles: e.array(s).readonly(),
  iat: e.number().optional(),
  exp: e.number().optional()
}).readonly(), p = e.object({
  id: r,
  username: i.optional(),
  title: e.string().min(1).optional(),
  privileges: e.array(o).readonly(),
  refreshToken: t.optional()
}).readonly();
export {
  p as AuthUserSchema,
  A as JwtPayloadSchema,
  n as PrivilegeEnum,
  o as PrivilegeSchema,
  d as UserRoleEnum,
  s as UserRoleSchema
};
//# sourceMappingURL=schemas.js.map
